"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickElement = void 0;
var ClickElement;
(function (ClickElement) {
    ClickElement["SearchHistoryDelete"] = "Search history delete";
    ClickElement["SearchMorePopularExperiences"] = "Search more popular experiences";
    ClickElement["SearchMoreLastSeenExperiences"] = "Search more last seen experiences";
    ClickElement["SearchMoreMatchingExperiences"] = "Search more matching experiences";
    ClickElement["MapInBuybox"] = "Map in buybox";
    ClickElement["TicketLocation"] = "Ticket location";
    ClickElement["TicketDate"] = "Ticket date";
    ClickElement["TicketTime"] = "Ticket time";
    ClickElement["TicketCount"] = "Ticket count";
    ClickElement["DeliveryCosts"] = "Delivery costs";
    ClickElement["AddToCart"] = "Add To Cart";
    ClickElement["WhatsApp"] = "Socialshare - WhatsApp";
    ClickElement["Link"] = "Socialshare - Link";
    ClickElement["EMail"] = "Socialshare - E-Mail";
    ClickElement["Close"] = "Socialshare - Close";
    ClickElement["PaybackInformation"] = "Payback Collect Information";
    ClickElement["PaybackAdditionalInformation"] = "Additional Information Payback";
    ClickElement["ProductInformation"] = "Product information";
    ClickElement["MapView"] = "Mapview";
    ClickElement["MapInDescription"] = "Map in description";
    ClickElement["PDPVariant"] = "PDP variant";
    ClickElement["SpvDate"] = "Spv Date";
    ClickElement["SpvTime"] = "Spv Time";
    ClickElement["ClickToCart"] = "Click To Cart";
    ClickElement["ClickToCancelDay"] = "Cancel Day Seletion";
    ClickElement["BackToProviderList"] = "Back To Provider List";
    ClickElement["LinkToPartnerChat"] = "Link To Partner Chat";
    ClickElement["LinkToDirectContact"] = "Link To Direct Contact";
    ClickElement["ButtonToAddVoucherToCart"] = "Button To Add Voucher To Cart";
    ClickElement["BackToPDP"] = "Back to PDP";
    ClickElement["ClickToBooking"] = "Click To Booking";
    ClickElement["OpenDetailsOfExperience"] = "Open Details Of Experience";
    ClickElement["PaginationNext"] = "Pagination Next";
    ClickElement["PaginationPrevious"] = "Pagination Previous";
    ClickElement["PaginationSelector"] = "Pagination Selector";
    ClickElement["SelectSpvOption"] = "Select Spv Option";
    ClickElement["EcomCTA"] = "EcomCTA";
    ClickElement["BookingLink"] = "Booking Link";
    ClickElement["MapInExperienceSelection"] = "Map In Experience Selection";
    ClickElement["ProceedToLastCheck"] = "proceed to last check";
    ClickElement["B2BLink"] = "b2b link";
    ClickElement["AddressCorrection"] = "address_correction";
    ClickElement["ExperienceCategories"] = "Erlebniskategorien";
    ClickElement["OpenBurgerNavigation"] = "open burger navigation";
    ClickElement["CloseBurgerNavigation"] = "close burger navigation";
    ClickElement["ChooseAlternativeExperienceForExistingVoucher"] = "Choose alternative experience for existing voucher";
    ClickElement["BuddyVoucherInfo"] = "Buddy voucher information popup";
    ClickElement["OpenQuantityDropdown"] = "Open quantity dropdown";
    ClickElement["LogIn"] = "Log In";
    ClickElement["SignUpConfirmationPage"] = "Sign-up confirmation page";
    ClickElement["OpenPromoBannerDescription"] = "open promotion banner description";
    ClickElement["OpenReviewSection"] = "Open review section";
    ClickElement["SlideReviewSection"] = "slide review section";
    ClickElement["AddVoucher"] = "Add Voucher to Voucher Overview";
    ClickElement["RedeemVoucherInVoucherOverview"] = "Redeem Voucher in Voucher Overview";
    ClickElement["DownloadVoucherInVoucherOverview"] = "Voucher Download in Voucher Overview";
    ClickElement["DeleteVoucherInVoucherOverview"] = "Delete Voucher in Voucher Overview";
    ClickElement["OpenPrintedVoucherPreview"] = "open printed voucher preview";
    ClickElement["OpenPDFPreview"] = "open PDF preview";
    ClickElement["ClosePDFPreview"] = "close PDF Preview";
    ClickElement["ClosePrintedVoucherPreview"] = "close printed voucher preview";
    ClickElement["MemberPdpPromotion"] = "Member PDP Promotion Banner";
    ClickElement["CloseExpirationReminderBanner"] = "close expiration reminder banner";
    ClickElement["ActivateExpirationReminder"] = "activate expiration reminder";
    ClickElement["CloseExpirationReminderPopup"] = "close expiration reminder popup";
    ClickElement["ConfirmEmailExpirationReminderPopup"] = "confirm email in expiration reminder popup";
    ClickElement["SubscribeToNewsletter"] = "subscribe to newsletter";
    ClickElement["RedeemValueVocher"] = "redeem value voucher";
    ClickElement["Benefits"] = "benefits";
    ClickElement["ClubDealStarTextPDP"] = "club deal star text PDP";
    ClickElement["ProductListStarTextPopupPDP"] = "productlist star text popup PDP";
    ClickElement["TermsAndConditionsStarTextPopupPDP"] = "terms and conditions star text popup PDP";
    ClickElement["CloseStarTextPopupPDP"] = "close star text popup PDP";
    ClickElement["ClusterScrollPDP"] = "autoscroll productselectorblock";
    ClickElement["DeleteCustomerAccount"] = "delete customer account";
})(ClickElement || (exports.ClickElement = ClickElement = {}));
//# sourceMappingURL=ClickElement.js.map